import { type Client, graphql, prefetch } from "@opensea/graphql"
import { FeaturedItemSlideFragment } from "@/components/collection/overview/components/ContentBlockModule/components/FeaturedItemSlide/FeaturedItemSlide.fragment"

export const CollectionRarestItemsQuery = graphql(
  `
    query CollectionRarestItemsQuery($collectionSlug: String!) {
      collectionRarestListedItems(collectionSlug: $collectionSlug) {
        ... on Item {
          id
          ...FeaturedItemSlide
        }
      }
    }
  `,
  [FeaturedItemSlideFragment],
)

export const prefetchCollectionRarestItemsQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionRarestItemsQuery, { collectionSlug })
}
